import { Application } from "@hotwired/stimulus"

const application = Application.start()

if (process.env.NODE_ENV === "development") {
  window.Stimulus = application
  application.debug = true
}

const context = require.context(".", true, /_controller\.js$/)
context.keys().forEach(path => {
  const mod = context(path)
  const name = path
    .replace(/^\.\//, "")
    .replace(/_controller\.js$/, "")
    .replace(/\//g, "--")
    .replace(/_/g, "-")
  application.register(name, mod.default)
})
